<script lang="ts" setup>
	import {storeToRefs} from 'pinia';
	import {useAppStore} from '@/store/app.store';
	import {useFavoriteProductStore} from '@/store/favorite.product.store';

	const emit = defineEmits(['favorites-cleared']);

	const favoriteStore = useFavoriteProductStore();
	const {confirmClearFavoritesModalActive} = storeToRefs(useAppStore());

	const onConfirm = () => {
		favoriteStore.clear();
		favoriteStore.toggleFavoriteView();
		emit('favorites-cleared');
		confirmClearFavoritesModalActive.value = false;
	}
</script>

<template>
	<Teleport to=".catalog-body">
		<div v-if="confirmClearFavoritesModalActive"
		     class="catalog-confirm-clear-favorites-modal show-confirm-clear-favorites-modal">
			<div class="catalog-confirm-clear-favorites-modal__inner">
				<div class="catalog-modal">
					<h3>{{ $t('site.products.overview.favorites.clear.title') }}</h3>
					<p>{{ $t('site.products.overview.favorites.clear.text') }}</p>
				</div>

				<div class="catalog-modal catalog-modal__button_bar">
					<button class="button button--white button--small"
					        type="button"
					        @click.prevent="confirmClearFavoritesModalActive = false">
						{{ $t('site.products.overview.favorites.clear.button.cancel.text') }}
					</button>
					<button class="button button--green button--small"
					        type="button"
					        @click.prevent="onConfirm">
						{{ $t('site.products.overview.favorites.clear.button.confirm.text') }}
					</button>
				</div>
			</div>
		</div>
	</Teleport>
</template>
